import { useDispatch } from "react-redux";
import { useRef, useEffect, useState } from "react";

import {
  fetchSection,
  setPageNum,
} from "../../../redux/action-creaters/section";
import styles from "./index.module.scss";
import Loader from "../loader";

export default function Pagen({
  count,
  size,
  currentNum,
  isShowShowMore = false,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null); // 👈 ref для наблюдения
  const observerRef = useRef(null); // чтобы отключить предыдущий observer
  const pageSize = size;
  const page = currentNum;
  const pagesCnt = Math.ceil(count / pageSize);

  useEffect(() => {
    if (!bottomRef.current || !isShowShowMore || page >= pagesCnt) return;

    // Удаляем предыдущий observer
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(
      async ([entry]) => {
        if (entry.isIntersecting && !loading) {
          setLoading(true);
          await dispatch(setPageNum(page + 1));
          await dispatch(fetchSection());
          setLoading(false);

          if (typeof ym !== "undefined") {
            // eslint-disable-next-line no-undef
            ym(20518312, "reachGoal", "showMore");
          }
        }
      },
      {
        rootMargin: "200px",
      },
    );

    observerRef.current.observe(bottomRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [bottomRef.current, page, pagesCnt, isShowShowMore, loading]);

  return (
    <div className={styles.Buttom} ref={bottomRef}>
      {loading && <Loader />}
    </div>
  );
}
